export default "__VITE_ASSET__CDzU1V9r__"